/*@flow*/

export default function flatten(...args: any[]): any[] {
  let flat = [];
  args.forEach(function(arg) {
    if (arg instanceof Array) {
      flat.push.apply(flat, flatten.apply(this, arg));
    } else {
      flat.push(arg);
    }
  });
  return flat;
}
